import { CSSProperties, ReactNode, useState } from 'react';

import VerifiedBadgeSvg from '@/components/common/svg/shapes/VerifiedBadgeShape';
import UIConfig from '@/UIConfig';
import { CandidateUI } from '@/api/matchmaker/types.ts';
import Modal from '@/animations/Modal.tsx';
import UserProfilePopup from '@/components/Popup/UserProfile/UserProfilePopup.tsx';

interface IProps {
  matchCandidate: CandidateUI;
  subtitle: ReactNode;
  content?: ReactNode;
  isPreview?: boolean;
}

const Bio = ({ matchCandidate, subtitle, content, isPreview }: IProps) => {
  const [userProfileOpened, setUserProfileOpened] = useState<boolean>(false);
  const [userProfileHid, setUserProfileHid] = useState<string | undefined>(
    undefined
  );

  const closeUserProfile = () => {
    setUserProfileOpened(false);
    setUserProfileHid(undefined);
  };

  const openUserProfile = (userHid?: string) => {
    setUserProfileHid(userHid);
    setUserProfileOpened(true);
  };

  const { name, age } = matchCandidate.profile;

  return (
    <>
      <div style={containerStyle}>
        <div
          style={itemStyle}
          onClick={(e) => {
            e.stopPropagation();
            openUserProfile(
              !isPreview ? matchCandidate.profile.hid : undefined
            );
          }}
        >
          <div style={nameAgeStyle}>
            {name}
            {age !== 0 && <span>,&nbsp;{age}</span>}
            &nbsp;
            <VerifiedBadgeSvg width={24} height={24} />
          </div>
          {subtitle}
          {content}
        </div>
      </div>
      <Modal fullScreen open={userProfileOpened} handleClose={closeUserProfile}>
        <UserProfilePopup
          handleClose={closeUserProfile}
          userHid={userProfileHid}
          hideBackButton={!isPreview}
          isSelfPreview={isPreview}
        />
      </Modal>
    </>
  );
};

const containerStyle: CSSProperties = {
  color: 'white',
  textAlign: 'left',
  width: '100%',
  position: 'absolute',
  bottom: '0px',
  left: '0px',
  zIndex: 3,
  paddingBottom: '10px',
  background: 'linear-gradient(transparent 0%, rgba(0, 0, 0, 0.7) 100%)',
  pointerEvents: 'auto'
};

const itemStyle: CSSProperties = {
  width: 'calc(100% - 25px)',
  marginLeft: '15px',
  marginTop: '13px',
  marginBottom: '5px'
};

export const nameAgeStyle: CSSProperties = {
  ...UIConfig.Typography.Card.Title,
  margin: '12px 0px 7px',
  display: 'flex',
  flexFlow: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start'
};

export default Bio;
